import React from 'react';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
    let navigate = useNavigate();
    const routeRegister = () => {
        let path = '/register';
        navigate(path);
    };

    return (
        <div id="landing">
            <div id="text">
                <h1>Finspace</h1>
                <p>Investing Socially.</p>
                <p>
                    Intuitive analysis tools for stocks, ETFs, Crypto, and more.
                    Share your thoughts with friends and followers, and see what
                    other people are thinking about.
                </p>
                <button
                    type="button"
                    className="btn button-secondary"
                    onClick={routeRegister}
                >
                    Request Access
                </button>
            </div>
        </div>
    );
};

export default Landing;
